import { LatexBlockComponent } from './latex-block';

export function effects() {
  customElements.define('affine-latex', LatexBlockComponent);
}
